import { Theme } from '@theme'
import { StyleSheet } from 'react-native'

export default (theme: Theme) =>
  StyleSheet.create({
    backIcon: {
      position: 'absolute',
      left: theme.spacing.lg,
      top: theme.spacing.sm,
      zIndex: 1,
      padding: theme.spacing.xxs,
      borderRadius: theme.border.jumbo,
      borderWidth: 1,
      borderColor: theme.colors.grey,
      backgroundColor: theme.colors.background,
      alignItems: 'center',
      justifyContent: 'center',
    },
    contentContainer: {
      paddingVertical: theme.spacing.xxxl,
      flexDirection: 'row',
      gap: theme.spacing.lg,
    },
    separator: {
      paddingBottom: theme.spacing.md,
    },
    refreshContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      marginTop: theme.spacing.xs,
      paddingHorizontal: theme.spacing.lg,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap',
      rowGap: theme.spacing.xs,
      columnGap: 20,
    },
    locationContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      flexShrink: 1,
      minWidth: 0,
    },
    infoContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      gap: 15,
      paddingHorizontal: theme.spacing.md,
    },
    rightContainer: {
      flex: 1,
    },
    editIcon: {
      alignSelf: 'flex-end',
      marginRight: theme.spacing.sm,
    },
    name: {
      flex: 1,
      textAlign: 'left',
    },
    titleContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: theme.spacing.xs,
    },
    locationText: {
      marginLeft: theme.spacing.xs,
    },
    work: {
      marginBottom: theme.spacing.xs,
    },

    content: {
      flex: 1,
    },
    container: {
      marginHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.xl,
      borderWidth: 1,
      borderColor: theme.colors.grey,
      borderRadius: theme.border.jumbo,
    },
    actionButtonsContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-around',
      paddingHorizontal: theme.spacing.lg,
      marginBottom: theme.spacing.lg,
    },
  })
